import {AbstractFilterComponent} from "./abstract-filter-component.js";
import {FilterParentingCheckboxList} from "./components/parenting-checkbox-list.js";

export class FilterLocations extends AbstractFilterComponent {

	static selector = '.js-filter-locations';

	checkboxList;

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.bindEvents();
		this.initChildren();
		this.update();
		this.initGroupsVisibility();
	}

	bindEvents() {
		let self = this;
		let filter = self.node;

		let preview = filter.querySelector('.js-filter-locations__preview');
		if (preview) {
			preview.addEventListener('click', function () {
				let fx = filter.classList.contains('active') ? 'remove' : 'add';
				filter.classList[fx]('active');
			});
		}

		let overlay = filter.querySelector('.js-filter-locations__overlay');
		if (overlay) {
			overlay.addEventListener('click', function () {
				filter.classList.remove('active');
			});
		}

		let closers = Array.prototype.slice.call(filter.querySelectorAll('.js-filter-locations__close'));
		closers.forEach(close => {
			close.addEventListener('click', function () {
				filter.classList.remove('active');
			});
		});

		let discard = filter.querySelector('.js-filter-locations__discard');
		if (discard) {
			discard.addEventListener('click', function () {
				self.checkboxList.setCheckedState(false);
			});
		}

		let submit = filter.querySelector('.js-filter-locations__submit');
		if (submit) {
			submit.addEventListener('click', function () {
				filter.classList.remove('active');
				self.parent['forceUpdate'](0);
			});
		}

		let dropIcons = Array.prototype.slice.call(filter.querySelectorAll('.js-filter-locations__item-icon'));
		dropIcons.forEach(icon => {
			icon.addEventListener('click', function (event) {
				event.preventDefault();

				let parentId = icon.closest('label').htmlFor;
				if (! parentId) {
					return true;
				}

				let show = ! icon.classList.contains('active');
				self.setGroupVisibility(parentId, show);

				icon.classList[show ? 'add' : 'remove']('active');

				return false;
			});
		});
	}

	initGroupsVisibility() {
		let self = this;

		let dropIcons = Array.prototype.slice.call(self.node.querySelectorAll('.js-filter-locations__item-icon'));
		dropIcons.forEach(icon => {
			let parentId = icon.closest('label').htmlFor;
			if (! parentId) {
				return true;
			}

			let show = icon.classList.contains('active');
			self.setGroupVisibility(parentId, show);

			icon.classList[show ? 'add' : 'remove']('active');
		});
	}

	setGroupVisibility(parentId, show = true) {
		let self = this;

		Array.prototype.slice.call(self.node.querySelectorAll(`.js-filter-checkbox-child[data-parent="${parentId}"]`)).forEach(input => {
			let label = self.node.querySelector(`label[for="${input.id}"]`);
			if (label) {
				label.classList[show ? 'remove' : 'add']('u-hidden');
			}
		});
	}

	initChildren() {
		let self = this;
		self.checkboxList = new FilterParentingCheckboxList(self, self.filter, self.node);
	}

	getLabels() {
		let self = this;
		return self.checkboxList.getLabels();
	}

	childComponentChangedState(child) {
		let self = this;
		self.update();
		self.componentStateChanged(self);
	}

	update() {
		let self = this;

		let labels = self.checkboxList.getLabels();
		self.updatePreviewField(labels.filter(Boolean));
	}

	updatePreviewField(labels) {
		let self = this;
		let preview = self.node.querySelector('.js-filter-locations__preview-content');

		let parts = [];
		if (! labels.length) {
			parts.push(preview.dataset.placeholder);
		} else {
			labels.map(label => {
				parts.push(label.getContent());
			});
		}

		preview.innerHTML = parts.join(', ');
	}

	getFormData() {
		let self = this;

		return self.checkboxList.getFormData();
	}

	onFilterUpdate(autoUpdate) {
		let self = this;

		if (! autoUpdate) {
			self.node.classList.remove('active');
		}
	}
}
